import{b as o}from"./chunk-VA3IQYLI.js";import{m as r}from"./chunk-HBP5N4FR.js";r();import e from"react";var a=({children:t})=>e.createElement("div",{className:o.footer},t);export{a};
//# sourceMappingURL=chunk-2BLZGAC4.js.map
